import { render, staticRenderFns } from "./VRequestSolutionModal.vue?vue&type=template&id=0cbc67e2"
import script from "./VRequestSolutionModal.vue?vue&type=script&lang=js"
export * from "./VRequestSolutionModal.vue?vue&type=script&lang=js"
import style0 from "./VRequestSolutionModal.vue?vue&type=style&index=0&id=0cbc67e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports